import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, Repository } from 'typeorm';
import { UserEntity } from '../user/user.entity';
import { AllRoleActivityByUserResponseModel } from './dto/role-activity-response.module';
import { getroleActivitysDTO } from './dto/role-activity.dto';
import { RoleActivityEntity } from './role-activity.entity';

@Injectable()
export class RoleActivityService {
    constructor(
        @InjectRepository(RoleActivityEntity)
        private roleActivityRepository: Repository<RoleActivityEntity>,
        @InjectRepository(UserEntity)
        private userRepo:Repository<UserEntity>
    ) {}

    async assignRoleActivity(dataToPost) {
        try {
            const savedActivity = await this.roleActivityRepository.save(dataToPost);
            if(savedActivity) {
                return true;
            } else { 
                return false;
            }            
        } catch (error) {
            throw error;
        }
    }

    async updateAssignedRoleActivity(activityId, roleIds) {
        try {
            if(roleIds) {
                await this.roleActivityRepository.update({activityId:activityId},{status:false});
                roleIds.map((el) => {
                    const existRecord = this.roleActivityRepository.findOne({
                        where:{activityId:activityId, roleId:parseInt(el)}
                    }) 
                    if(existRecord) {
                        this.roleActivityRepository.update({activityId:activityId, roleId:parseInt(el)},{status:true});
                    } else {
                        this.roleActivityRepository.save({
                            activityId:activityId, roleId:parseInt(el), status:true
                        })
                    }
                })
                return true;
            } else {
                return null;
            }
        } catch (error) {
            throw error;
        }
    }

   
       async getActivitiesByUserId(queryParams, getroleactdto:getroleActivitysDTO, request:Request):Promise<AllRoleActivityByUserResponseModel> {
        const response = new AllRoleActivityByUserResponseModel();
        try {
            let activities: any[] = [];
            await this.userRepo.update({Id:getroleactdto.userId},{fcmToken:getroleactdto.fcmToken})
            if(queryParams.apiVersion == 1) {
                const user = await this.userRepo.findOne({
                    relations:['profile','roles'],
                    where:{Id:getroleactdto.userId}
                });
                if(!user) {
                    throw new ErrorResponse(99908, 'User not found')
                }
                const activity = await this.roleActivityRepository.find({
                    relations:['activity'],
                    where:{roleId:user.roleId, status:true},
                    order: { activityId: 'ASC' }
                }) 
                if(activity) {
                    const da = activity.map((file) => {
                        return {
                            Id: file.activity.activityId,
                            activityId: file.activity.activityId,
                            activity: file.activity.activityName,
                        };
                    });
                    da.map((act) => {
                        activities.push({ Id: act.Id, activityId:act.activityId,activityName:act.activity });
                    });
                    const finalData = {
                        userId:user.Id,
                        roleId:user.roleId,
                        roleName:user.roles.roleName,
                        mobileNo:user.mobileNo,
                        firstName: `Hi, Welcome ${user.profile.firstName}`,
                        profilePic: user.profile.profilePic != null ? `${process.env.WORKINGURL}/${user.profile.profilePic}` : '',
                        activity:activities
                    }
                    response.status = true;
                    response.data = finalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else  {
                const user = await this.userRepo.findOne({
                    relations:['profile','roles'],
                    where:{Id:getroleactdto.userId}
                });
                const activity = await this.roleActivityRepository.find({
                    relations:['activity'],
                    where:{roleId:user.roleId, status:true},
                    order: { activityId: 'ASC' }
                })
                if(activity) {
                    const da = activity.map((file) => {
                        return {
                            Id: file.activity.activityId,
                            activityId: file.activity.activityId,
                            activity: file.activity.activityName,
                        };
                    });
                    da.map((act) => {
                        activities.push({ Id: act.Id, activityId:act.activityId,activityName:act.activity });
                    });
                    const finalData = {
                        userId:user.Id,
                        roleId:user.roleId,
                        roleName:user.roles.roleName,
                        mobileNo:user.mobileNo,
                        firstName: `Hi, Welcome ${user.profile.firstName}`,
                        profilePic: user.profile.profilePic != null ? `${process.env.WORKINGURL}/${user.profile.profilePic}` : '',
                        activity:activities
                    } 
                    response.status = true;
                    response.data = finalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}
     
